import { render, staticRenderFns } from "./ObjectGroupsPage.vue?vue&type=template&id=038bee23&"
import script from "./ObjectGroupsPage.vue?vue&type=script&lang=js&"
export * from "./ObjectGroupsPage.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGroupsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
